var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15077_28398)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15077_28398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92677 4.89377C4.84813 5.07197 4.80469 5.29029 4.80469 5.54422V20.2801C4.80469 20.5348 4.84827 20.7534 4.92716 20.9316L12.9453 12.9123L4.92677 4.89377ZM5.39044 21.4106C5.6876 21.5376 6.07515 21.4972 6.49774 21.2575L15.9304 15.8974L13.4164 13.3835L5.39044 21.4106ZM16.5317 15.5564L19.4912 13.875C20.422 13.3453 20.422 12.4797 19.4912 11.9507L16.5309 10.2685L13.8875 12.9123L16.5317 15.5564ZM15.93 9.92711L6.49774 4.56744C6.07486 4.32713 5.68706 4.28708 5.38983 4.41454L13.4164 12.4411L15.93 9.92711Z",
    fill: "#FFFCFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92677 4.89377C4.84813 5.07197 4.80469 5.29029 4.80469 5.54422V20.2801C4.80469 20.5348 4.84827 20.7534 4.92716 20.9316L12.9453 12.9123L4.92677 4.89377ZM5.39044 21.4106C5.6876 21.5376 6.07515 21.4972 6.49774 21.2575L15.9304 15.8974L13.4164 13.3835L5.39044 21.4106ZM16.5317 15.5564L19.4912 13.875C20.422 13.3453 20.422 12.4797 19.4912 11.9507L16.5309 10.2685L13.8875 12.9123L16.5317 15.5564ZM15.93 9.92711L6.49774 4.56744C6.07486 4.32713 5.68706 4.28708 5.38983 4.41454L13.4164 12.4411L15.93 9.92711Z",
    fill: "#FFFCFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15077_28398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.499756)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15077_28398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.499756)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.1a420046c39b6e3e78d410fd64f4828b.svg";
export { ForwardRef as ReactComponent };